import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import { UserPreferencesModule } from '@helios/user-preferences'
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DaterangeModule,
  InlineEditModule,
  NfFormsModule,
  NumberModule,
} from '@northfork/ng-basics'
import { AdvancedOptionsComponent } from './components/advanced-options/advanced-options.component'
import { ColumnTypePickerComponent } from './components/column-type-picker/column-type-picker.component'
import { FilterEditorRowComponent } from './components/filter-editor-row/filter-editor-row.component'
import { FilterEditorComponent } from './components/filter-editor/filter-editor.component'
import { FilterGridComponent } from './components/filter-grid/filter-grid.component'
import { FilterModalControlsComponent } from './components/filter-modal-controls/filter-modal-controls.component'
import { FilterModalComponent } from './components/filter-modal/filter-modal.component'

@NgModule({
  imports: [
    CommonModule,
    NgbModalModule,
    ButtonModule,
    HttpClientModule,
    TableLayoutModule,
    GenericComponentsModule,
    NgbNavModule,
    UserPreferencesModule,
    NgbTooltipModule,
    NgbDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    NfFormsModule,
    InlineEditModule,
    NgSelectModule,
    DaterangeModule,
    NumberModule,
  ],
  declarations: [
    FilterModalComponent,
    FilterGridComponent,
    FilterEditorComponent,
    FilterEditorRowComponent,
    AdvancedOptionsComponent,
    FilterModalControlsComponent,
    ColumnTypePickerComponent,
  ],
  // ColumnTypePickerComponent is exported so a panel's own custom ag-Grid filter can host the SAME
  // control in the grid-header popover — the point of the picker is that both surfaces present one
  // control writing one store, so it cannot be modal-private.
  exports: [
    FilterModalComponent,
    FilterModalControlsComponent,
    ColumnTypePickerComponent,
  ],
  providers: [],
})
export class FilterModalModule {}
